import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { NTA_COLORS, NTA_LANGUAGE_NOTE } from '../constants';
import {
  ntaBodyCss,
  ntaNoteCss,
  ntaPageCss,
  ntaSectionTitleCss
} from '../typography';
import { parseNtaStructuredPayload } from './ntaStructuredInstructions';
import NtaStructuredInstructionsView from './NtaStructuredInstructionsView';

const Body = styled.div`
  width: 100%;
  ${ntaPageCss}
`;

const SectionsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

const SectionBlock = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding-top: ${({ $first }) => ($first ? '24px' : '0')};
`;

const LanguageNote = styled.p`
  margin: 0;
  padding: 16px;
  border-radius: 12px;
  background: ${NTA_COLORS.white};
  ${ntaNoteCss}
`;

const DynamicHtml = styled.div`
  ${ntaBodyCss}

  p {
    margin: 0 0 8px;
  }

  ol,
  ul {
    margin: 0;
    padding: 0 0 0 24px;
  }

  li {
    margin-bottom: 8px;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  h1,
  h2,
  h3 {
    margin: 0 0 8px;
    color: ${NTA_COLORS.textPrimary};
    ${ntaSectionTitleCss}
  }
`;

const InstructionsBody = ({ instructionsHtml }) => {
  const structured = parseNtaStructuredPayload(instructionsHtml);

  if (structured) {
    return (
      <Body>
        <NtaStructuredInstructionsView payload={structured} />
      </Body>
    );
  }

  return (
    <Body>
      <SectionsColumn>
        <SectionBlock $first>
          <DynamicHtml
            dangerouslySetInnerHTML={{ __html: instructionsHtml || '' }}
          />
        </SectionBlock>
        <LanguageNote>{NTA_LANGUAGE_NOTE}</LanguageNote>
      </SectionsColumn>
    </Body>
  );
};

export default InstructionsBody;

InstructionsBody.propTypes = {
  instructionsHtml: PropTypes.string
};

InstructionsBody.defaultProps = {
  instructionsHtml: ''
};
